module.exports = __webpack_public_path__ + "assets/99e47b80862a22d750734d85c611ac6c.mp3";